import { render, staticRenderFns } from "./FkeNarrativeSummary.vue?vue&type=template&id=5ba2c033&scoped=true"
import script from "./FkeNarrativeSummary.vue?vue&type=script&lang=js"
export * from "./FkeNarrativeSummary.vue?vue&type=script&lang=js"
import style0 from "./FkeNarrativeSummary.vue?vue&type=style&index=0&id=5ba2c033&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba2c033",
  null
  
)

export default component.exports